import useSWR, { SWRConfiguration } from 'swr';
import hash from 'object-hash';
import { AxiosError } from 'axios';
import { Invoice } from '../../../providers/api/dtos';
import { getInvoices, InvoicesProviderFilters } from '../../../providers/api/invoice/invoiceProvider';
import { PaginatedResult, PaginationParams } from '../../../providers/pagination';
import { useMatchMutate } from '../../../utils/swr/swr';
import { SWRCustomResponse } from '../../../hooks/types';

export const USE_INVOICES_RID = '/api/v4/invoices';

export default function useInvoices(
  filters?: InvoicesProviderFilters,
  pagination?: PaginationParams,
  options: SWRConfiguration<PaginatedResult<Invoice>, AxiosError> & { shouldFetch?: boolean } = {},
): SWRCustomResponse<PaginatedResult<Invoice>, AxiosError> {
  const matchMutate = useMatchMutate();
  const key = [USE_INVOICES_RID, hash({ ...filters, ...pagination })];
  const result = useSWR(key, () => getInvoices(filters, pagination), options);

  return {
    ...result,
    mutate: () => matchMutate(USE_INVOICES_RID),
  };
}
